<template lang="pug">
  treeselect(:options="options", :placeholder="placeholder", :value="value", @input="$emit('input', $event)", :clearable="clearable", v-bind="treeselect_options", :append-to-body="true", :disabled="disabled", :async="async", :load-options="loadOptions", :default-options="defaultOptions", :limit="limit", :multiple="multiple", :searchable="searchable", :disable-branch-nodes="disableBranchNodes")
</template>

<script>
import treeselectOptions from '@/data/treeselect-options'

export default {
  data () {
    return {
      treeselect_options: treeselectOptions,
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: null,
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultOptions: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    loadOptions: null,
    limit: {
      type: Number,
      default: Infinity
    },
    multiple: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    disableBranchNodes: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
